// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1__f57ca70f1bebf1cb62c3","cls2":"ResearchInterestTags-cls2___a889794f45c49594827 ResearchInterestTags-cls1__f57ca70f1bebf1cb62c3"};